import { render } from "./CustomModal.vue?vue&type=template&id=0703dd64&scoped=true"
import script from "./CustomModal.vue?vue&type=script&lang=js"
export * from "./CustomModal.vue?vue&type=script&lang=js"

import "./CustomModal.vue?vue&type=style&index=0&id=0703dd64&lang=scss"
import "./CustomModal.vue?vue&type=style&index=1&id=0703dd64&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0703dd64"]])

export default __exports__